// extracted by css-extract-rspack-plugin
export default {"link":"FileInfoPanelItem_link__rrlzO"};